export const TOKEN_KEY =
  'c6f959a9062f16bbe7298df45221af68492ae3c940003df0c66a88ec70bc2c65';
export const USERNAME = TOKEN_KEY + '__USER';
export const SYNC = TOKEN_KEY + '__SYNC';

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUsername = () => localStorage.getItem(USERNAME);

export const login = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const username = (username) => {
  localStorage.setItem(USERNAME, username);
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const syncRequests = () => {
  return localStorage.getItem(SYNC);
};

export const setSyncRequests = (count) => {
  localStorage.setItem(SYNC, count);
};
